import { createAsyncThunk } from '@reduxjs/toolkit'

import { api } from '@/apiClient/api'
import { isErrorAPIError } from '@/apiClient/helpers'
import type { GetOffererResponseModel } from '@/apiClient/v1'
import { FrontendError } from '@/commons/errors/FrontendError'
import { handleError } from '@/commons/errors/handleError'
import {
  LOCAL_STORAGE_KEY,
  localStorageManager,
} from '@/commons/utils/localStorageManager'

import type { AppThunkApiConfig } from '../../store'
import { setSelectedAdminOfferer } from '../reducer'
import { logout } from './logout'

export const setSelectedAdminOffererById = createAsyncThunk<
  void,
  number | GetOffererResponseModel,
  AppThunkApiConfig
>(
  'user/setSelectedAdminOffererById',
  async (offererOrOffererId, { dispatch, getState }) => {
    try {
      const state = getState()
      const offererNamesPendingIds = state.user.offererNames?.map(
        (o) => !o.validated && o.id
      )
      const offererId =
        typeof offererOrOffererId === 'number'
          ? offererOrOffererId
          : offererOrOffererId.id

      if (
        offererNamesPendingIds &&
        offererNamesPendingIds.length > 0 &&
        offererNamesPendingIds.includes(offererId)
      ) {
        // if the offerer is unattached, we set a minimal offerer to avoid having getOfferer() return a 403
        // this allows to display the unattached banner to the user
        const minimalOfferer = {
          id: offererId,
        } as GetOffererResponseModel
        dispatch(setSelectedAdminOfferer(minimalOfferer))
        localStorageManager.setItem(
          LOCAL_STORAGE_KEY.SELECTED_ADMIN_OFFERER_ID,
          String(offererId)
        )
        return
      }

      const nextOfferer =
        typeof offererOrOffererId === 'number'
          ? await api.getOfferer({
              path: { offerer_id: offererOrOffererId },
            })
          : offererOrOffererId
      dispatch(setSelectedAdminOfferer(nextOfferer))
      localStorageManager.setItem(
        LOCAL_STORAGE_KEY.SELECTED_ADMIN_OFFERER_ID,
        String(nextOfferer.id)
      )
    } catch (err) {
      handleError(
        err,
        "Une erreur est survenue lors du chargement de l'entité juridique."
      )
      if (
        (isErrorAPIError(err) && err.status !== 0) ||
        err instanceof FrontendError
      ) {
        await logout()
      }
    }
  }
)
